import React from "react";
import { Button } from "antd";


export default function ExpiredLinkPage() {
  return (
    <div id="expired-link" className="error-page">
    <h1> Link Expired </h1>
    <div className="error-page_content">
      <p className="error-page_content-message"> This link has expired. Please check your email for a new link or contact support if you need assistance. </p>
    </div>
    <div className="error-page_action-buttons">
      <Button color="primary" variant="solid" href="/web">
        Back to Home
      </Button>
    </div>
  </div>
  )
};